import React from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from '@pandiafi/design-system'

import { ErrorPage } from 'views/ErrorPage'
import { useReturnToPreviousView } from 'hooks/useReturnToPreviousView/useReturnToPreviousView'

interface AccessDeniedPageProps {
  message?: string
  // Set only when an error boundary renders the page
  resetErrorBoundary?: () => void
}

export const AccessDeniedPage: React.FC<AccessDeniedPageProps> = ({
  message,
  resetErrorBoundary,
}) => {
  const { t } = useTranslation(['errors', 'common'])
  const returnToPreviousView = useReturnToPreviousView()

  return (
    <ErrorPage
      message={message ?? t('errors:other.featureAccessDenied')}
      illustration="house-locked"
      action={
        <Button
          onClick={() => {
            returnToPreviousView()
            resetErrorBoundary?.()
          }}
        >
          {t('common:back')}
        </Button>
      }
    />
  )
}
